import { PointElement } from 'chart.js'

const indicatorOptions = {
    radius: 5, borderWidth: 1, backgroundColor: '#CCEBFF', borderColor: '#30A7FE'
}

export default function (chart, e, options) {
    const x = e.x
    const eventY = e.y
    const items = []
    const metas = chart.getSortedVisibleDatasetMetas()
    for (let i = 0; i < metas.length; i++) {
        const meta = metas[i]
        const pt = meta.dataset.interpolate({ x }, 'x')
        const closestPoint = chart.scales[meta.xAxisID].getValueForPixel(x)
        if (closestPoint < 0) continue

        if (Math.abs(meta.data[closestPoint].x - x) < 2 && Math.abs(meta.data[closestPoint].y - eventY) < 3) {
            items.push({ element: meta.data[closestPoint], index: closestPoint, datasetIndex: meta.index })
            meta._pt = null
            continue
        }

        if (pt && Math.abs(eventY - pt.y) < 10) {
            const element = new PointElement({ ...pt, options: { ...indicatorOptions } })
            meta._pt = element
            items.push({ element, index: -1, datasetIndex: meta.index })
        } else {
            meta._pt = null
        }
    }

    return items
};
